import { render, staticRenderFns } from "./management-library-control-type-view.vue?vue&type=template&id=6c8db6c1&"
import script from "./management-library-control-type-view.vue?vue&type=script&lang=js&"
export * from "./management-library-control-type-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports